module.exports = __webpack_public_path__ + "img/成功@3x 2.84a1020a.png";